import React from 'react';
import { X } from 'lucide-react';

/**
 * Hülle der Filtermenüs auf dem Handy (28.10.2026): dieselben Menüs wie am Rechner, unter 769 px als
 * Blatt von unten mit Titel und abgedunkeltem Hintergrund (App.css, `.blatt-*`). Am Rechner sind
 * Kopf und Hintergrund ausgeblendet. Der Hintergrund fängt das Tippen ab, damit es nicht die Card
 * darunter öffnet.
 */
export const BlattHintergrund: React.FC<{ onClose: () => void }> = ({ onClose }) => (
  <div className="blatt-hintergrund" onClick={onClose} aria-hidden />
);

export const BlattKopf: React.FC<{ titel: string; onClose: () => void }> = ({ titel, onClose }) => (
  <div className="blatt-kopf">
    <strong>{titel}</strong>
    <button type="button" onClick={onClose} aria-label="Schließen"><X size={18} aria-hidden /></button>
  </div>
);

/** Auf dem Handy nicht sofort ins Suchfeld: die Tastatur deckte das halbe Blatt zu. */
export const amRechner = () => typeof window !== 'undefined' && window.matchMedia('(min-width: 769px)').matches;

/**
 * Fuß des Blatts auf dem Handy (Vorbild Tripadvisor, Spotify): links diesen Filter zurücksetzen,
 * rechts „N Events anzeigen“. Die Wahl wirkt schon beim Tippen; der Knopf schließt das Blatt und
 * nennt die Zahl, die sonst erst hinter dem Blatt zu sehen wäre.
 */
export const BlattFuss: React.FC<{ treffer?: number; onZuruecksetzen?: () => void; onFertig: () => void }> = ({ treffer, onZuruecksetzen, onFertig }) => (
  <div className="blatt-fuss">
    <button type="button" className="blatt-fuss-zurueck" onClick={onZuruecksetzen} disabled={!onZuruecksetzen}>Zurücksetzen</button>
    <button type="button" className="blatt-fuss-fertig" onClick={onFertig}>
      {treffer == null ? 'Fertig' : treffer === 1 ? '1 Event anzeigen' : `${treffer.toLocaleString('de-DE')} Events anzeigen`}
    </button>
  </div>
);
